<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="p-2 item-view-primary-action-btn items-center justify-center flex flex-grow"
  >
    <div
      v-if="button_type == 'edit_post'"
      class="cursor-pointer edit-action-btn"
      @click="editData(edit_post_data)"
    >
      <feather-icon icon="EditIcon" :svgClasses="['h-4 w-4']" />

      <span class="text-sm font-semibold ml-2">EDIT</span>
    </div>
    <feather-icon
      v-if="button_type == 'edit_data_icon'"
      icon="EditIcon"
      svgClasses="w-5 h-5 hover:text-primary stroke-current"
      @click.stop="editData(edit_post_data)"
    />

    <div class="">
      <vs-button
        v-if="button_type == 'add_new'"
        @click="activePrompt = true"
        class="w-full"
        >{{ button_title }}</vs-button
      >
      <vs-prompt
        title="New Health Hacks Category"
        accept-text="Save"
        button-cancel="border"
        @cancel="clearFields"
        @accept="addNewCategory"
        @close="clearFields"
        :is-valid="validateCategoryForm"
        :active.sync="open_category_dialog"
        class="new-category-popup"
      >
        <div>
          <form action>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Category Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="Category Name"
                  placeholder="Category Name"
                  class="w-full"
                  v-model="category_form.category_name"
                  :color="validateCategoryForm ? 'success' : 'danger'"
                />
              </div>
            </div>
          </form>
        </div>
      </vs-prompt>

      <vs-prompt
        title="New Health Hacks Post"
        accept-text="Save"
        button-cancel="border"
        @cancel="clearFields"
        @accept="AddPostAPICall"
        @close="clearFields"
        :is-valid="validateForm"
        :active.sync="activePrompt"
        class="new-health-hacks-post"
      >
        <div>
          <form>
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Category</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <v-select
                      :options="categories"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      v-validate="'required'"
                      name="category"
                      placeholder="Category"
                      class="w-full"
                      v-model="taskLocal.category"
                      @input="changeCategoryName"
                      :color="validateForm ? 'success' : 'danger'"
                    />
                  </div>
                  <div class="vx-col sm:w-1/3 w-1">
                    <vs-button @click="openCategoryDialog" class="link">
                      <feather-icon
                        icon="PlusCircleIcon"
                        :svgClasses="['h-4 w-4']"
                      />
                      Add category
                    </vs-button>
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Video URL</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                      v-validate="'required'"
                      name="video URL"
                      placeholder="Video URL"
                      class="w-full"
                      v-model="taskLocal.video_url"
                      :color="validateForm ? 'success' : 'danger'"
                    />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Video title</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                      v-validate="'required'"
                      name="video title"
                      placeholder="Video title"
                      class="w-full"
                      v-model="taskLocal.video_title"
                      :color="validateForm ? 'success' : 'danger'"
                    />
                  </div>
                </div>
                <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Published</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-switch
                      v-model="taskLocal.status_published"
                      class="mt-2 mr-1"
                    >
                      <span slot="on"></span>
                      <span slot="off"></span>
                    </vs-switch>
                  </div>
                </div>
                <!-- <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Order</span>
                  </div>
                  <div class="vx-col sm:w-2/3 w-full">
                    <vs-input
                      v-validate="'required'"
                      name="Order"
                      type="number"
                      placeholder="Order"
                      class="w-full"
                      v-model="taskLocal.order"
                      :color="validateForm ? 'success' : 'danger'"
                    />
                  </div>
                </div> -->
                
                <!-- <div class="vx-row mb-6">
                  <div class="vx-col sm:w-1/3 w-full">
                    <span>Thumbnail</span>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <vx-input-group class="mb-base">
                      <input
                        type="file"
                        accept="image/x-png,image/jpeg"
                        ref="file"
                        style="display: none"
                        @change="onFileChange"
                      />
                      <vs-button
                        type="flat"
                        @click="$refs.file.click()"
                        class="btn-action"
                      >
                        <span v-if="edit_picture_url">Edit image</span>
                        <span v-else>Attach a image</span>
                      </vs-button>
                    </vx-input-group>
                  </div>
                  <div class="vx-col sm:w-1/3 w-full">
                    <img
                      style="width: 100%"
                      v-if="taskLocal.thumbnail"
                      :src="taskLocal.thumbnail"
                      alt="Image"
                    />
                  </div>
                </div> -->
              </div>
            </div>
          </form>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DataProvider from "../../../services/data-provider";
import Constant from "../../../services/constant";
import firebase from "firebase";
// import * as firebase from "firebase";
export default {
  components: {
    "v-select": vSelect,
  },
  props: {
     all_data: {
      type: Array,
    },
    button_type: {
      type: String, 
    },
    button_title: {
      type: String,
    },
    edit_post_data: {
      type: Object,
    },
    categories: {
      type: Array,
    },
    categories_obj:{
      type:Array
    }
  },
  created() {
    this.photos_ref = firebase.storage().ref("/health_hacks/");
  },
  data() {
    return {
      activePrompt: false,
      open_category_dialog: false,
      is_added_new_category: false,
      old_category: "",
      old_order_number: "",
      edit_id: "",
      data_len: "",
      edit_data: false,
      base64_picture: "",
      nav_picture: "",
      photos_ref: "",
      edit_picture_url: "",

      category_form: {
        category_name: "",
      },
      taskLocal: {
        category: "",
        video_url: "",
        video_title: "",
        // thumbnail: "",
        questions: [],
        status_published: true,
        order: null,
      },
    };
  },
  computed: {
    taskTags() {
      return this.$store.state.todo.taskTags;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.taskLocal.category != "" &&
        this.taskLocal.video_url != "" &&
        this.taskLocal.video_title != ""
      );
    },
    validateCategoryForm() {
      return !this.errors.any() && this.category_form.category_name != "";
    },
  },
  methods: {
    changeCategoryName(event){
      console.log(event)
      console.log(this.all_data)
      if(this.button_type == 'add_new'){
      let index=0
      this.all_data.filter(item=>{
        if(item.category==event){
          index=index+1
        }
      })
      console.log(index+1)
      this.taskLocal.order=(index+1)
      }
    },
    onFileChange(event) {
      const file = event.target.files[0];
      this.firstFileToBase64(file).then(
        (result) => {
          this.base64_picture = result;
          this.taskLocal.thumbnail = result;
          this.nav_picture = "";
          var image = result.includes("image/jpeg;base64,")
            ? result.split("image/jpeg;base64,")
            : result.split("image/png;base64,");
          console.log(image);
          this.nav_picture = image[1];
          // this.uploadPhoto();
        },
        (err) => {
          this.base64_picture = "";
        }
      );
    },
    uploadPhoto() {
      this.$vs.loading();
      console.log(this.edit_picture_url);
      if (this.nav_picture) {
        if (this.edit_picture_url != "" && this.edit_picture_url != undefined) {
          if (this.edit_picture_url.includes("health_hacks%2F")) {
            let str1 = this.edit_picture_url.split("health_hacks%2F");
            let img_name = str1[1].split("?");
            let health_hacks_img_ref = this.photos_ref.child(img_name[0]);
            health_hacks_img_ref
              .delete()
              .then((del_res) => {
                console.log("image delete:", del_res);
                this.edit_picture_url = "";
                // File deleted successfully
              })
              .catch((error) => {
                console.log("image delete an error occurred!:", error);
                // Uh-oh, an error occurred!
              });
          }
        }
        console.log("this.photos_ref::", this.photos_ref);
        let upload_photo = this.nav_picture;
        let unique_id = this.generateUUID();
        this.upload_pic_task = this.photos_ref
          // .child(this.uid)
          .child(unique_id + "picture.png")
          .putString(upload_photo, "base64", { contentType: "image/png" });
        this.upload_pic_task.then((savedPicture) => {
          this.getVenueImage(savedPicture);
        });
      } else {
        this.AddPostAPICall();
      }
    },
    generateUUID() {
      var d = new Date().getTime();
      var uuid = "xxxx-xxx-4xx-yxxx".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    firstFileToBase64(fileImage) {
      return new Promise((resolve, reject) => {
        let fileReader = new FileReader();
        if (fileReader && fileImage != null) {
          fileReader.readAsDataURL(fileImage);
          fileReader.onload = () => {
            resolve(fileReader.result);
          };

          fileReader.onerror = (error) => {
            reject(error);
          };
        } else {
          reject(new Error("No file found"));
        }
      });
    },
    getVenueImage(image) {
      let imgUrl;
      var vm = this;
      this.upload_pic_task.snapshot.ref.getDownloadURL().then(function (url) {
        console.log("url: " + url);
        vm.taskLocal.thumbnail = url;
        vm.AddPostAPICall();
        //   vm.is_loading=false;

        // vm.select_picture = url;
      });
    },
    addNewCategory() {
      this.categories = this.categories.push(this.category_form.category_name);
      this.is_added_new_category = true;
      // DataProvider.addNewCategory(this.category_form).then((data) => {
      //   conaole.log("data", data);
      // });
    },
    openCategoryDialog() {
      this.open_category_dialog = true;
    },
    clearFields() {
      // Object.assign(this.taskLocal, {
        this.taskLocal.category= "",
        this.taskLocal.video_url= "",
        this.taskLocal.video_title= "",
        // thumbnail: "",
      // });
      this.edit_data = false;
      this.edit_id = "";
      this.edit_picture_url = "";
      this.old_order_number = null;
      this.is_added_new_category=false
      this.category_form.category_name=''
    },
    getCategories() {
      DataProvider.getDataFromCloud("/health_hacks_categories").then(
        (data) => {
          console.log("data", data);
          if (data.data) {
            this.categories = data.data;
          }
        },
        (err) => {
          DataProvider.sendSentryErrorLog(err);
        }
      );
    },
    AddPostAPICall() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          if (this.edit_data == false) {
            // if (this.taskLocal.thumbnail == "") {
            //   this.taskLocal.thumbnail = Constant.thumbnail_placehoder;
            // }
            DataProvider.postDataToCloud("/health_hacks/"+(this.is_added_new_category?this.categories_obj[this.categories_obj.length-1].collection_order?(this.categories_obj[this.categories_obj.length-1].collection_order+1):(this.categories_obj.length+1):false), this.taskLocal).then(
              (data) => { 
                if (this.is_added_new_category) this.$emit("reload_categories");
                this.$vs.loading.close();
                console.log("Data:", data);
                this.$emit("reload_post_data");
                this.clearFields();
              },
              (err) => {
                this.$vs.loading.close();
                console.log(err);
                DataProvider.sendSentryErrorLog(err);
                if (err.message.includes("403")) {
                  this.$vs.notify({
                    color: "warning",
                    title: "Access denied!",
                  });
                }
              }
            );
          } else {
            let old_category_changed;
            let is_order_changed = "no-change";
            let old_order_number = "no-change";
            this.taskLocal.id = "";
            this.taskLocal.id = this.edit_id;
            this.taskLocal.order = parseInt(this.taskLocal.order);
            if (this.old_category == this.taskLocal.category) {
              old_category_changed = "no-change";
              if (this.old_order_number == this.taskLocal.order) {
              } else {
                is_order_changed = this.taskLocal.order;
                old_order_number =
                  this.old_order_number == ""
                    ? "no-change"
                    : this.old_order_number;
              }
            } else {
              old_category_changed = this.old_category.split(" ").join("_");
            }
            DataProvider.updateFirestoreCloudData(
              "/health_hacks/" +
                this.edit_id +
                "/" +
                old_category_changed +
                "/" +
                is_order_changed +
                "/" +
                old_order_number,
              this.taskLocal
            ).then(
              (data) => {
                this.$vs.loading.close();
                if (this.is_added_new_category) this.$emit("reload_categories");
                console.log("Data:", data);
                this.$emit("reload_post_data");
                this.clearFields();
              },
              (err) => {
                this.$vs.loading.close();
                console.log(err);
                DataProvider.sendSentryErrorLog(err);
                if (err.message.includes("403")) {
                  this.$vs.notify({
                    color: "warning",
                    title: "Access denied!",
                  });
                }
              }
            );
          }
        }
      });
    },
    addTodo() {
      console.log(this.taskLocal);
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(result);
          this.uploadPhoto();
        }
      });
    },
    openNew() {
      this.activePrompt = true;
    },
    editData(data) {
      console.log(data);
      this.activePrompt = true;
      this.edit_data = true;
      this.edit_id = data.id;
      this.taskLocal.category = data.category;
      this.taskLocal.video_url = data.video_url;
      this.taskLocal.video_title = data.video_title;
      // this.taskLocal.thumbnail = data.thumbnail;
      this.taskLocal.questions = data.questions;
      this.taskLocal.status_published = data.hasOwnProperty("status_published")
        ? data.status_published
        : true;
      this.taskLocal.order = data.order ? data.order : "";
      // this.edit_picture_url = data.thumbnail;
      this.old_category = data.category;
      this.old_order_number = data.order ? data.order : "";
    },
  },
};
</script>
<style lang="scss">
.item-view-primary-action-btn {
  color: #2c2c2c !important;

  min-width: 50%;
}
.edit-action-btn {
  background-color: #f6f6f6;
  text-align: center;
  width: 100%;
}
.new-category-popup.vs-dialog-primary {
  z-index: 99999;
}
.v-select {
  text-transform: capitalize;
  li {
    text-transform: capitalize;
  }
}
.vs__selected {
  text-transform: capitalize;
}
</style>
